<dx-button
  (onClick)="filterChange.emit(id)"
  [class.filter-active]="selected"
>
  <div class="status">
    <div
      *ngIf="indicatorColor"
      class="status-indicator"
      [ngClass]="{ hashed: hashed }"
      [ngStyle]="indicatorStyle"
    ></div>
    <div [ngClass]="selected ? 'status-label' : ''">{{ label }}</div>
    <div
      class="status-counter"
      [ngStyle]="selected ? selectedStyle : unselectedStyle"
    >
      {{ count }}
    </div>
  </div>
</dx-button>
